<template>
  <v-container class="fill-height" fluid>
    <!-- ログイン中のローディングÏ -->
    <div v-if="isNowLoggingIn()">
      <v-overlay z-index="1000">
        <v-card class="text-center black--text" color="white">
          <v-card-title>{{ loggingOverlayMessage }}</v-card-title>
          <v-card-text>
            <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-overlay>
    </div>

    <v-row align="center" justify="center">
      <v-col cols="12" sm="10">
        <v-card class="elevation-6" style="padding: 10px">
          <v-card-title>
            <img class="img-fluid" src="/images/aid-32.png" style="max-width: 80%;" />
            <span class="aid-logotype ml-3" style="white-space: nowrap;">AgriBus-Web</span>
          </v-card-title>
          <v-form lazy-validation ref="form" v-model="valid">
            <v-row align="center" justify="center">
              <v-col cols="10" md="4" class="mr-6 sp-nomargin">
                <v-btn
                  outlined
                  block
                  color="black"
                  large
                  class="darken-2 mt-1 pl-2 pr-2"
                  @click="startGoogleOAuth"
                  dark
                >
                  <img class="img-fluid" src="/images/google_logo.png" style="width:32px" />
                  <span class="aid-logotype ml-1" style="white-space: nowrap;font-weight:bold;">{{
                    $tt('customGoogleOAuthBtn')
                  }}</span>
                </v-btn>
              </v-col>
              <v-col class="pc-none mt-5" cols="10">
                <v-divider></v-divider>
              </v-col>
              <v-divider vertical class="sp-none"></v-divider>
              <v-col cols="12" md="7">
                <v-card-text>
                  <v-text-field
                    :error-messages="emailErrors"
                    :label="$tt('customEmail')"
                    @blur="$v.email.$touch()"
                    placeholder="you@example.com"
                    prepend-icon="person"
                    required
                    v-model="email"
                  />
                  <v-text-field
                    :error-messages="passwordErrors"
                    :label="$tt('customPassword')"
                    @blur="$v.password.$touch()"
                    @click:append="show = !show"
                    placeholder="password"
                    prepend-icon="lock"
                    required
                    type="password"
                    v-model="password"
                  />
                  <v-checkbox :label="$tt('customRememberMe')" v-model="rememberMe"></v-checkbox>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    :disabled="!valid"
                    @click.stop.prevent="login"
                    block
                    class="white--text text-none"
                    color="primary"
                    type="submit"
                    >{{ $tt('SignInButton') }}
                  </v-btn>
                </v-card-actions>
                <v-card-actions>
                  <!-- パスワードを忘れた場合 -->
                  <v-btn :to="{ name: 'UserResetPassword' }" class="text-none" color="primary" small text
                    >{{ $tt('ToResetPasswordButton') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <!-- アカウントをお持ちでない場合 -->
                  <v-btn @click="nowShowingAboutSignUp = true" class="text-none pt-1 pc-none" small text
                    >{{ $tt('customYouDontHaveAccount') }}
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-form>

          <v-divider></v-divider>
          <!-- アカウントをお持ちでない場合 -->
          <v-btn @click="nowShowingAboutSignUp = true" class="text-none pt-1 sp-none" small text absolute bottom left
            >{{ $tt('customYouDontHaveAccount') }}
          </v-btn>
          <v-card-actions class="d-flex justify-center">
            <footer-component :isShowSpecifiedCommercialTransactionLaw="isShowSpecifiedCommercialTransactionLaw" />
          </v-card-actions>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn absolute bottom class="text-none grey--text text--darken-2" right text v-on="on" x-small>
                <v-icon small class="mr-1">language</v-icon>
                {{ getSelectedLanguageText() }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group color="primary" v-model="selectedLanguageIndex">
                <v-list-item v-for="(language, index) in languages" :key="index" @click="onLanguageSelected(language)">
                  <v-list-item-title>{{ language.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-card>
      </v-col>
    </v-row>

    <!-- アカウントをお持ちでない場合ダイアログ -->
    <v-dialog max-width="1200" persistent v-model="nowShowingAboutSignUp">
      <v-card style="padding: 20px">
        <v-card-title>
          <h3>{{ $tt('customRegisterAgriBusWeb') }}</h3>
        </v-card-title>
        <v-row align="center" justify="center">
          <v-col cols="10" md="5" class="mr-6 sp-nomargin">
            <v-btn outlined block color="black" large class="darken-2 mt-1 pl-2 pr-2" @click="startGoogleOAuth" dark>
              <img class="img-fluid" src="/images/google_logo.png" style="width:32px" />
              <span class="aid-logotype ml-1" style="white-space: nowrap;font-weight:bold;">{{
                $tt('customGoogleOAuthSignUpBtn')
              }}</span>
            </v-btn>
          </v-col>
          <v-col class="pc-none mt-5" cols="10">
            <v-divider></v-divider>
          </v-col>
          <v-divider vertical class="sp-none"></v-divider>
          <v-col cols="12" md="6">
            <v-card-text>
              <v-form lazy-validation ref="signUpForm" v-model="signUpValid">
                <v-text-field
                  :error-messages="signUpEmailErrors"
                  :label="$tt('customEmail')"
                  @blur="$v.signUpEmail.$touch()"
                  placeholder="you@example.com"
                  prepend-icon="person"
                  required
                  v-model="signUpEmail"
                ></v-text-field>
                <v-text-field
                  :error-messages="signUpPasswordErrors"
                  :label="$tt('customPassword')"
                  @blur="$v.signUpPassword.$touch()"
                  @click:append="show = !show"
                  placeholder="password"
                  prepend-icon="lock"
                  required
                  type="password"
                  v-model="signUpPassword"
                />
                <v-checkbox :label="$tt('SendMeNews')" v-model="signUpSendMeNews"></v-checkbox>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="closeSignUpWindow()">{{ $tt('customCancel') }}</v-btn>
              <v-btn @click="simpleSignUpAndSignIn" color="warning" :disabled="!signUpValid"
                >{{ $tt('customRegistration') }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import FooterComponent from '@/components/FooterComponent'
import ApplicationConfig from '@/lib/application-config'
import * as Constants from '@/lib/constants'
import i18n from '@/lib/i18n'
import locale from '@/lib/locale'
import storage from '@/lib/storage'
import Toast from '@/lib/toast'
import { validationMixin } from 'vuelidate'
import { email, required, minLength, maxLength, helpers } from 'vuelidate/lib/validators'
import moment from 'moment/moment'

const passwordValidator = helpers.regex('passwordValidator', /^(?=.*?[0-9])(?=.*?[a-z]){8,60}$/i)

export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required },
    signUpEmail: { required, email },
    signUpPassword: {
      required,
      maxLength: maxLength(Constants.PASSWORD_MAX_LENGTH_ON_COGNITO),
      minLength: minLength(Constants.PASSWORD_MIN_LENGTH_ON_COGNITO),
    },
  },

  components: { FooterComponent },

  mounted() {
    this.initLanguage()
  },

  methods: {
    startGoogleOAuth() {
      let endpoint =
        ApplicationConfig.getCognitoBaseUrl() +
        '/oauth2/authorize?identity_provider=Google&response_type=token&client_id=' +
        ApplicationConfig.getCongitoClientId() +
        '&redirect_uri='
      const redirect = this.$route.query.redirect
      if (redirect === '/sso/shopify') {
        endpoint = endpoint + ApplicationConfig.getGoogleOAuthRedirectForSSOUrl()
      } else {
        endpoint = endpoint + ApplicationConfig.getGoogleOAuthRedirectUrl()
      }
      window.location.href = endpoint
    },
    initLanguage() {
      const lang = (
        (window.navigator.languages && window.navigator.languages[0]) ||
        window.navigator.language ||
        window.navigator.userLanguage ||
        window.navigator.browserLanguage
      ).substr(0, 2)
      for (let i = 0; i < this.languages.length; i++) {
        if (this.languages[i].value === lang) {
          this.selectedLanguageIndex = i
        }
      }
      this.setLanguage(this.languages[this.selectedLanguageIndex].value)
    },
    isNowLoggingIn() {
      return this.$store.getters.nowLoggingIn
    },
    login() {
      const redirect = this.$route.query.redirect
      let nextRoute = '/feed'
      if (redirect) {
        nextRoute = redirect
      }
      this.loggingOverlayMessage = this.$tt('customNowLoggingIn')
      const loginInfo = {
        credentials: {
          email: this.email,
          password: this.password,
          rememberMe: this.rememberMe,
        },
        nextRoute: nextRoute,
      }
      this.$store.dispatch('authLogin', loginInfo)
    },
    setLanguage(language) {
      this.isShowSpecifiedCommercialTransactionLaw = i18n.isShowSpecifiedCommercialTransactionLaw(language)
      i18n.setUserLangByLanguage(language)
    },
    getLanguage() {
      return storage.getUserLangConsideringDefault()
    },
    isLanguage(lang) {
      return storage.getUserLangConsideringDefault() === lang
    },
    onLanguageSelected(language) {
      this.setLanguage(language.value)
    },
    getSelectedLanguageText() {
      return this.languages[this.selectedLanguageIndex].name
    },
    closeSignUpWindow() {
      this.nowShowingAboutSignUp = false
    },
    simpleSignUp() {
      this.loggingOverlayMessage = this.$tt('customSimpleSignUpNow')
      this.$v.$touch()
      if (!this.$refs.signUpForm.validate()) {
        return null
      }
      const request = {
        email: this.signUpEmail,
        language: this.languages[this.selectedLanguageIndex].value,
        zoneinfo: moment.tz.guess(), // バグ修正: 20230726 zoneinfo: locale.detectCurrent(),
        onSignUpSuccessHandler: this.closeSignUpWindow,
      }
      this.$store.dispatch('simpleSignUp', request)
    },
    simpleSignUpAndSignIn() {
      this.loggingOverlayMessage = this.$tt('customSimpleSignUpNow')
      this.$v.$touch()
      if (!this.$refs.signUpForm.validate()) {
        return null
      }
      const redirect = this.$route.query.redirect
      let nextRoute = '/feed'
      if (redirect) {
        nextRoute = redirect
      }
      // email/passwordの空白文字はvuelidateで防御されるが、リクエスト送信前にも除去を行う
      const request = {
        email: this.signUpEmail.replace(/\s/g, ''),
        password: this.signUpPassword.replace(/\s/g, ''),
        sendMeNews: this.signUpSendMeNews,
        language: this.languages[this.selectedLanguageIndex].value,
        zoneinfo: moment.tz.guess(), // バグ修正: 20230726 zoneinfo: locale.detectCurrent(),
        onSignUpSuccessHandler: this.closeSignUpWindow,
        nextRoute: nextRoute,
      }
      this.$store.dispatch('authSimpleSignUpAndSignIn', request)
    },
  },
  data: () => ({
    email: null,
    password: ApplicationConfig.getDefaultUser().password,
    rememberMe: true,

    loggingOverlayMessage: undefined,

    nowShowingAboutSignUp: false,
    valid: true,
    selectedLanguageIndex: 1,
    languages: [
      { name: '日本語', value: 'ja' },
      { name: 'English', value: 'en' },
      { name: 'Português', value: 'pt' },
      { name: 'Espanol', value: 'es' },
      { name: 'Deutsch', value: 'de' },
      { name: 'Polski', value: 'pl' },
      { name: 'Pусский', value: 'ru' },
      { name: 'ภาษาไทย', value: 'th' },
    ],
    productDetailsUrlMap: new Map([
      ['de', 'https://agri-info-design.com/en/agribus-navi/'],
      ['en', 'https://agri-info-design.com/en/agribus-navi/'],
      ['es', 'https://agri-info-design.com/es/agribus-navi/'],
      ['ja', 'https://agri-info-design.com/agribus-navi/'],
      ['ru', 'https://agri-info-design.com/ru/agribus-navi/'],
      ['pt', 'https://agri-info-design.com/pt-br/agribus-navi/'],
      ['pl', 'https://agri-info-design.com/pl/agribus-navi/'],
      ['th', 'https://agri-info-design.com/th/agribus-navi/'],
    ]),

    signUpEmail: null,
    signUpPassword: null,
    signUpSendMeNews: true,
    signUpValid: false,
    isShowSpecifiedCommercialTransactionLaw: true,
  }),
  computed: {
    emailErrors() {
      let errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push(this.$tt('ValidationBadEmail'))
      !this.$v.email.required && errors.push(this.$tt('ValidationTextRequired'))
      return errors
    },
    passwordErrors() {
      let errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push(this.$tt('ValidationTextRequired'))
      return errors
    },
    signUpEmailErrors() {
      let errors = []
      if (!this.$v.signUpEmail.$dirty) return errors
      !this.$v.signUpEmail.email && errors.push(this.$tt('ValidationBadEmail'))
      !this.$v.signUpEmail.required && errors.push(this.$tt('ValidationTextRequired'))
      return errors
    },
    signUpPasswordErrors() {
      let errors = []
      if (!this.$v.signUpPassword.$dirty) return errors
      !this.$v.signUpPassword.required && errors.push(this.$tt('ValidationTextRequired'))
      !this.$v.signUpPassword.minLength &&
        errors.push(this.$tt('customValidationPasswordMinLength', { length: Constants.PASSWORD_MIN_LENGTH_ON_COGNITO }))
      !this.$v.signUpPassword.maxLength && errors.push(this.$tt('customValidationPasswordMaxLength'))
      const regex = new RegExp('^(?=.*[a-z])(?=.*[0-9]).*$', 'g')
      if (!regex.test(this.signUpPassword)) {
        errors.push(this.$tt('customNewPasswordValidationError'))
      }

      return errors
    },
    i18nCustomPleaseSignUpFromAndroidApplication() {
      return i18n.tt('customPleaseSignUpFromAndroidApplication')
    },
    i18nCustomWhatIsAgribusNAVI() {
      return i18n.tt('customWhatIsAgribusNAVI')
    },
    i18nCustomAgriBusNAVIDescription() {
      return i18n.tt('customAgriBusNAVIDescription')
    },
  },
}
</script>
<style scoped>
.center-item {
  position: absolute;
  top: 5%;
  left: -23%;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 30px;
  height: 56px;
  background-color: #fff;
}

.center-item-signup {
  position: absolute;
  top: 22%;
  left: -6%;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 30px;
  height: 56px;
  background-color: #fff;
}

.center-item p,
.center-item-signup p {
  text-align: center;
  margin-top: 16px;
}

.pc-none {
  display: none;
}

@media screen and (max-width: 960px) {
  .pc-none {
    display: block;
  }

  .sp-none {
    display: none;
  }

  .sp-nomargin {
    margin-right: 0 !important;
  }

  .center-item {
    top: -42%;
    left: 0;
    width: 60px;
  }

  .center-item-signup {
    top: -8%;
    left: 0;
    width: 60px;
  }
}
</style>
